import {getCountry} from '@/store/util';

const country = getCountry();

export const env = {
  NODE_ENV: 'development',
  CLIENT_ID: 'neodash_dev',
  URL: {
    HOST: `http://dv.neogig.com.${country}/neodash`,
    NEOGIG: `http://dv.neogig.com.${country}`,
    NEOGIG_API: `http://dv.neogig.com.${country}/neogig_api_core/api/v1`,
    NEOGIG_IMAGE: `http://dv.neogig.com.${country}/static/images`,
    NEODASH_API: `http://dv.neogig.com.${country}/neodash_api_core`,
    REPORT_VIEWER: `http://qa.neogig.com.${country}/neodash_reportviewer_identityserver`,
    CTRL_PANEL_API: `http://cp-api.qa.neogig.com.br`,
    IDENTITY_SERVER: `http://dv.neocom.bsb/identity_server`,
    WEBSOCKET: 'ws://dv.neogig.com.br/neodash_api/WsSocketHandler.ashx',
    PBIURL: `https://app.powerbi.com/`,
  }
};
